import React from 'react';
import PropTypes from 'prop-types';

import ShowAllTableButton from "./ShowAllTableButton";

import TextDate from "components/text/TextDate";
import TextAmount from 'components/text/TextAmount';
import TextPercent from 'components/text/TextPercent';


class PointList extends React.Component {

  state = {
    showAll : false,
    oldestDueDate : this.props.oldestDueDate,
    calculateToDate : this.props.calculateToDate,    
  };

  constructor(props){
    super(props);
    this.showTableClick = this.showTableClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ calculateToDate: nextProps.calculateToDate });
    this.setState({ oldestDueDate: nextProps.oldestDueDate });
  }


  showTableClick(showAll){
    this.setState({ showAll: showAll });
  };

  isDateInRangeInList(itemNumber, list){
    let points = list;
    let item = points[itemNumber];

    if ((this.state.oldestDueDate === undefined)){
      return true;
    }

    if (itemNumber+1 < points.length)
    {
      let nextItem = points[itemNumber+1];
      if ((this.state.oldestDueDate < nextItem.pointDate) && (this.state.calculateToDate >= item.pointDate)){
        return true;
      }
    }
    else if (this.state.calculateToDate >= item.pointDate){
      return true;
    }
    return false;
  };




  render() {

    if ((!this.props.points) || (this.props.points.length === 0)){
      return (
        <div/>
      );
    }

    let points = this.props.points;
    let columnNumber = "2";
    let extraHeaderContent;
    let extraColContent;
    let hasExtra = false;
    let isPercent = this.props.isPercent;
    if (this.props.hasExtra) {
      columnNumber = "3";
      hasExtra = true;
      extraColContent = (
        <col />
      );
      extraHeaderContent = (
        <th className="text-left">Auka p.</th>
      );
    }

    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col width="80px" />
            <col />
            {extraColContent}
          </colgroup>
          <thead>
          <tr>
            <th colSpan={columnNumber-1} className="text-left calc-setting-table-header">{this.props.title}</th>
            <th className="text-right"><ShowAllTableButton showAll={this.state.showAll} handleShowHideClick={this.showTableClick}/> </th>
          </tr>
          <tr>
            <th className="text-left">Dagur</th>
            <th className="text-left">Punktur</th>
            {extraHeaderContent}
          </tr>
          </thead>
          <tbody>
          {points.map((item,i) => {
            let isPointInRage = this.isDateInRangeInList(i, points);
            if (!this.state.showAll && !isPointInRage ){
              return null;
            }

            let valueContent;
            let extraValueContent;
            if (isPercent){
              valueContent = (                
                <TextPercent value={item.value}/>
              );
            }
            else{
              valueContent = (
                <TextAmount value={item.value}/>
              );              
            }
            if (hasExtra){
              extraValueContent = (
                <td className="text-left"><TextAmount value={item.value}/></td>
              );
            }

            let shouldHighlightClass = ((isPointInRage && this.state.showAll) ? "calc-setting-table-highlight" : "" );

            return (
              <tr className={shouldHighlightClass} key={i}>
                <td className="text-left"><TextDate value={item.pointDate}/>
                </td>
                <td className="text-left">{valueContent}</td>
                {extraValueContent}
              </tr>);

          })}
          </tbody>
        </table>        
      </div>
    );
  }
}

PointList.propTypes = {
  title: PropTypes.string,
  isPercent : PropTypes.bool,
  points: PropTypes.array,
  hasExtra: PropTypes.bool,
  calculateToDate : PropTypes.object,
  oldestDueDate : PropTypes.object,
};



export default PointList;
